module.exports = __webpack_public_path__ + "img/cityApply.d91a9e61.jpg";